import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/metaverse-new/transform_meta.webp";

function Transformmetaverse() {
  return (
    <section
      className="transform_metaverse p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="offset-lg-7">
            <h2>Transform Your Brand with Our Metaverse Developers</h2>
            <p>
              It’s time to rethink your brand through the lens of the metaverse,
              driving long-term sustainable growth and creating immersive
              experiences that surpass conventional boundaries. As seasoned
              metaverse developers, TekRevol delivers user-centric solutions
              with a deep understanding of the intricate details that propel
              your brand to new heights. Let’s collaborate to achieve your
              ambitious goals and redefine your brand’s success.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Contact Us
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Transformmetaverse;
